import { useEffect, useState } from 'react';

/**
 * Reactive matchMedia. Used to keep JS-rendered layout decisions (e.g. the
 * hero deck vs the Trending rail dedupe) in lockstep with CSS breakpoints —
 * a CSS-only display:none would leave the sibling component unable to know
 * whether its content duplicates the hidden one.
 */
export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
};
